/**
 * ScrollManager — limits how far the user can scroll by setting
 * max-height + overflow:clip on #app. This physically caps the
 * element's box in body's layout, reducing scrollHeight.
 * The browser and Lenis naturally stop at the page boundary.
 *
 * Priority lock: when active, regular setMaxScroll calls are ignored.
 * Used by horizontal-scroll scenes that need an absolute lock.
 */
export class ScrollManager {
  private appEl: HTMLElement | null = null
  private limited = false
  private currentMaxHeight = 0
  private priorityActive = false

  init(): void {
    this.appEl = document.getElementById('app')
  }

  setMaxScroll(maxScrollY: number): void {
    if (!this.appEl || this.priorityActive) return

    const vh = window.innerHeight
    const maxHeight = Math.round(maxScrollY + vh)

    if (maxHeight !== this.currentMaxHeight) {
      this.currentMaxHeight = maxHeight
      this.appEl.style.maxHeight = `${maxHeight}px`
      this.appEl.style.overflow = 'clip'
    }
    this.limited = true
  }

  setPriorityLock(maxScrollY: number): void {
    if (!this.appEl) return
    this.priorityActive = true

    const vh = window.innerHeight
    const maxHeight = Math.round(maxScrollY + vh)

    this.currentMaxHeight = maxHeight
    this.appEl.style.maxHeight = `${maxHeight}px`
    this.appEl.style.overflow = 'clip'
    this.limited = true
  }

  clearPriorityLock(): void {
    this.priorityActive = false
    this.removeMaxScroll()
  }

  removeMaxScroll(): void {
    if (!this.appEl) return
    if (this.priorityActive) return
    if (this.currentMaxHeight !== 0) {
      this.appEl.style.maxHeight = ''
      this.appEl.style.overflow = ''
      this.currentMaxHeight = 0
    }
    this.limited = false
  }

  isLimited(): boolean {
    return this.limited
  }

  destroy(): void {
    this.priorityActive = false
    this.removeMaxScroll()
    this.appEl = null
  }
}

export const scrollManager = new ScrollManager()
